import Reflux from 'reflux';

const CodecTypesActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default CodecTypesActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/codecs/CodecTypesActions.js